"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * This component was created in order to add the aria-label attribute which is used
 * in the automation tests for selecting the necessary option value
 */
var Option = function Option(_ref) {
  var children = _ref.children,
    innerProps = _ref.innerProps,
    isSelected = _ref.isSelected,
    isFocused = _ref.isFocused,
    isDisabled = _ref.isDisabled;
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])({
      'select-component__option': true,
      'select-component__option--is-selected': isSelected,
      'select-component__option--is-focused': isFocused,
      'select-component__option--is-disabled': isDisabled
    })
  }, innerProps, {
    "aria-label": children
  }), children);
};
Option.defaultProps = {
  isDisabled: false,
  children: null
};
Option.propTypes = {
  children: _propTypes["default"].node,
  innerProps: _propTypes["default"].shape({}).isRequired,
  isSelected: _propTypes["default"].bool.isRequired,
  isFocused: _propTypes["default"].bool.isRequired,
  isDisabled: _propTypes["default"].bool
};
var _default = exports["default"] = Option;